/**
 * Determine if the given value is truthy.
 *
 * @param {mixed} value The value to test.
 * @param {boolean} convertBoolStrings Should '1' and '0' be converted.
 *
 * @returns{boolean} value True if truthy.
 */
export const isTruthy = (value, convertBoolStrings = true) => {
	// Convert Vue's observable object back to normal object.
	// @link https://github.com/vuejs/Discussion/issues/292
	if ('object' === typeof value) {
		value = JSON.parse(JSON.stringify(value));
	}

	// Now check to see if we have an array.
	if (Array.isArray(value)) {
		value = value.length;
	}

	// Maybe convert boolean strings. Ex:
	// Boolean('0') === true
	// Boolean(0) === false
	if (convertBoolStrings && ('0' === value || '1' === value)) {
		value = parseInt(value);
	}

	return Boolean(value);
};

/**
 * Determine if the given value is falsy.
 *
 * @param {mixed} value The value to test.
 * @param {boolean} convertBoolStrings Should '1' and '0' be converted.
 *
 * @returns{boolean} value True if falsy.
 */
export const isFalsy = (value, convertBoolStrings = true) => {
	return !isTruthy(value, convertBoolStrings);
};
